import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "notice-bar-wrap" }

import { ref, onMounted } from 'vue';
import { queryGamewInfoMessage } from "@/api";


export default {
  __name: 'NoticeBar',
  setup(__props) {

const activeNotice = ref({});
const noticeList = ref([])
const moving = ref(false);

onMounted(() => {
  fetchNotice();
})


const fetchNotice = () => {
  queryGamewInfoMessage().then(res => {
    noticeList.value = res.data || [];
    doNotice();
  });
}

const doNotice = () => {
  if (noticeList.value && noticeList.value.length > 0) {
    moving.value = true;
    activeNotice.value = noticeList.value.shift();
  } else {
    moving.value = false;
  }
}

return (_ctx, _cache) => {
  const _component_van_image = _resolveComponent("van-image")
  const _component_van_notice_bar = _resolveComponent("van-notice-bar")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_notice_bar, {
      scrollable: "",
      text: activeNotice.value.username ? _ctx.$t('notice.content').format({ user: activeNotice.value.username, amount: _ctx.$filter.outputAmount(activeNotice.value.bonus) }) : '',
      onReplay: doNotice
    }, {
      "left-icon": _withCtx(() => [
        _createVNode(_component_van_image, {
          class: "notice-icon",
          fit: "contain",
          src: require('@/assets/img/common/notice.png')
        }, null, 8, ["src"])
      ]),
      _: 1
    }, 8, ["text"])
  ]))
}
}

}